import { Buffertank } from '@/services/models/implementations/Buffertank'
import { BufferTankInfoText } from '@/helper/Types.ts'

class BufferTankVolume {

  public heating?: number
  public cooling?: number
  public combined?: number
  public defrosting?: number
  public heatingEffective?: number
  public coolingEffective?: number

  constructor(bufferTankVolume: Partial<BufferTankVolume>) {
    Object.assign(this, bufferTankVolume)
  }
}

export class BufferTankSuggestion {

  private readonly _heating: Buffertank[]
  private readonly _cooling: Buffertank[]
  private readonly _combined: Buffertank[]
  private readonly _minVolume?: BufferTankVolume
  private readonly _minFlowRate?: number
  private readonly _bufferTankInfoText?: BufferTankInfoText[]

  constructor(bufferTankSuggestion: Partial<BufferTankSuggestion>) {
    this._heating = bufferTankSuggestion.heating?.map(bufferTank => new Buffertank(bufferTank)) || []
    this._cooling = bufferTankSuggestion.cooling?.map(bufferTank => new Buffertank(bufferTank)) || []
    this._combined = bufferTankSuggestion.combined?.map(bufferTank => new Buffertank(bufferTank)) || []
    this._minFlowRate = bufferTankSuggestion.minFlowRate
    this._bufferTankInfoText = bufferTankSuggestion.bufferTankInfoText

    if (bufferTankSuggestion.minVolume) {
      this._minVolume = new BufferTankVolume(bufferTankSuggestion.minVolume)
    }
  }

  get minVolume(): BufferTankVolume | undefined {
    return this._minVolume
  }

  get minFlowRate(): number | undefined {
    return this._minFlowRate
  }

  get combined(): Buffertank[] {
    return this._combined
  }

  get heating(): Buffertank[] {
    return this._heating
  }

  get cooling(): Buffertank[] {
    return this._cooling
  }

  get bufferTankInfoText(): BufferTankInfoText[] | undefined {
    return this._bufferTankInfoText
  }

  get all(): Buffertank[] {
    return [...this._heating, ...this._cooling, ...this._combined]
  }
}
